import { render, staticRenderFns } from "./Spaces.vue?vue&type=template&id=25f9d608&"
import script from "./Spaces.vue?vue&type=script&lang=js&"
export * from "./Spaces.vue?vue&type=script&lang=js&"
import style0 from "./Spaces.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Spaces.vue"
export default component.exports